import { render, staticRenderFns } from "./ConsultarOfertasDescontosForm.vue?vue&type=template&id=da89b16e&scoped=true"
import script from "./ConsultarOfertasDescontosForm.vue?vue&type=script&lang=js"
export * from "./ConsultarOfertasDescontosForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultarOfertasDescontosForm.vue?vue&type=style&index=0&id=da89b16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da89b16e",
  null
  
)

export default component.exports